<template>
  <div v-if="frame" class="logic-tag">
  </div>
</template>
<script>

export default {
  name: 'logicTag',
  props: ['meta', 'frame', 'isLastFrame'],
  created() {
    this.initTag()
  },
  watch: {
    isLastFrame(isLast) {
      console.log('logicTag isLastFrame %s. current frame %v', isLast, this.frame)
      if (isLast && this.onLastFrame.action !== 'none') {
        this.$emit('action', this.onLastFrame)
      }
    },
    meta: 'initTag'
  },
  data() {
    return {}
  },
  computed: {},
  directives: {},
  methods: {
    initTag() {
      console.log('logicTag.inited', this.$vnode.tag)
      this.onLastFrame = this.meta.onLastFrame
    }
  }
}
</script>
